// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
// import messages from './local/index';

// i18n
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     lng: 'en',
//     fallbackLng: 'en',
//     debug: false,
//     resources: messages,
//     interpolation: {
//       escapeValue: false,
//     },
//   });

// export default i18n;




import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';  // ← your translations object

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'en',             // default/fallback language
    fallbackLng: 'en',
    debug: false,          // set to true during dev if needed
    resources: messages,
    interpolation: {
      escapeValue: false,  // React already escapes values
    },
  });

export default i18n;